<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.2946 9.9996C16.9053 9.61033 16.2743 9.60998 15.8846 9.99883L12 13.875L8.11538 9.99883C7.72569 9.60998 7.09466 9.61033 6.70538 9.9996C6.31581 10.3892 6.31581 11.0208 6.70538 11.4104L12 16.705L17.2946 11.4104C17.6842 11.0208 17.6842 10.3892 17.2946 9.9996Z" fill="currentColor"/>
</svg>
